import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=377c18c9&scoped=true&"
var script = {}
import style0 from "./agreement.scss?vue&type=style&index=0&id=377c18c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377c18c9",
  null
  
)

export default component.exports